<button
  mat-button
  type="button"
  (click)="toggleExpand()"
  [attr.aria-label]="ariaLabel"
>
  @if (!expanded) {
    <mat-icon>keyboard_arrow_down</mat-icon>
  } @else {
    <mat-icon>keyboard_arrow_up</mat-icon>
  }
  {{ buttonTitle }}
</button>

@if (expanded) {
  <div class="p-2 theme-bg-3">
    <ng-content></ng-content>
  </div>
}
